/*
*@Author: dcl
*@Description: 合作保险公司信息披露页面
*@Date: 2022-11-14 11:28:04
*/
<template>
<div class="ico">
    <el-table :data="companyList" height="13.5rem" :header-cell-style="headerstyle" :cell-style="cellStyle" style="width: 98%">
        <el-table-column prop="name" label="保险公司名称" min-width="95" align="center"></el-table-column>
        <el-table-column prop="date" label="合作起止时间" min-width="95" align="center"></el-table-column>
        <el-table-column prop="range" label="合作范围" min-width="70" align="center"></el-table-column>
        <el-table-column prop="website" label="官网" min-width="60" align="center"></el-table-column>
        <el-table-column prop="tel" label="客服电话" min-width="70" align="center"></el-table-column>
        <el-table-column prop="province" label="省级分支机构清单" min-width="160" align="center"></el-table-column>
        <el-table-column prop="area" label="落地服务机构清单" min-width="160" align="center"></el-table-column>
    </el-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            companyList: [{
                //     id: 1,
                //     name: "中国人民财产保险股份有限公司",
                //     date: "2021年9月1日 - 2024年8月31日",
                //     range: "财产险、意外险、健康险、车险",
                //     website: "http://www.epicc.com.cn/",
                //     tel: "95518",
                //     province: "北京、天津、河北、山西、内蒙古、辽宁、吉林、黑龙江、上海、安徽、福建、江西、山东、河南、湖北、湖南、广东、广西、海南、重庆、四川、贵州、云南、陕西、甘肃、青海、宁夏、新疆、西藏",
                //     area: "北京、天津、河北、山西、内蒙古、辽宁、吉林、黑龙江、上海、安徽、福建、江西、山东、河南、湖北、湖南、广东、广西、海南、重庆、四川、贵州、云南、陕西、甘肃、青海、宁夏、新疆、西藏"
                // },
                // {
                    id: 1,
                    name: "中国平安财产保险股份有限公司",
                    date: "2022年5月1日 - 2025年4月30日",
                    range: "财产险、意外险、健康险、车险",
                    website: "https://www.pingan.com/",
                    tel: "95511",
                    province: "北京、天津、河北、山西、内蒙古、辽宁、吉林、黑龙江、上海、江苏、浙江、安徽、福建、江西、山东、河南、湖北、湖南、广东、广西、海南、重庆、四川、贵州、云南、陕西、甘肃、青海、宁夏、新疆、西藏",
                    area: "北京、天津、河北、山西、内蒙古、辽宁、吉林、黑龙江、上海、江苏、浙江、安徽、福建、江西、山东、河南、湖北、湖南、广东、广西、海南、重庆、四川、贵州、云南、陕西、甘肃、青海、宁夏、新疆、西藏"
                },
                {
                    id: 2,
                    name: "中国大地财产保险股份有限公司",
                    date: "2024年12月11日 - 2025年11月30日",
                    range: "车险",
                    website: "http://www.ccic-net.com.cn/",
                    tel: "95590",
                    province: "北京市、天津市、河北省、山西省、内蒙古自治区、辽宁省、吉林省、黑龙江省、上海市、江苏省、浙江省、安徽省、福建省、江西省、山东省、河南省、湖北省、湖南省、 广东省、广西壮族自治区、海南省、重庆市、四川省、贵州省、云南省、陕西省、甘肃省、青海省、宁夏回族自治区、新疆维吾尔自治区和西藏自治区",
                    area: "北京市、天津市、河北省、山西省、内蒙古自治区、辽宁省、吉林省、黑龙江省、上海市、江苏省、浙江省、安徽省、福建省、江西省、山东省、河南省、湖北省、湖南省、 广东省、广西壮族自治区、海南省、重庆市、四川省、贵州省、云南省、陕西省、甘肃省、青海省、宁夏回族自治区、新疆维吾尔自治区和西藏自治区"
                }
            ]
        };
    },
    methods: {
        headerstyle() {
            return "font-size: .67rem;font-weight: normal;background-color:#FAFAFA;color: #666666;";
        },
        cellStyle() {
            return "font-size: 0.53rem;color: #666666;";
        }
    }
};
</script>

<style scoped lang='less'>
.ico {
  margin-top: .73rem;
}
</style>



// WEBPACK FOOTER //
// src/view/Information/cooperation.vue